<div class="row" ng-if="!widget.dataModelOptions.modal">
  <div class="col-xs-6">
    <ui-select ng-model="widget.dataModelOptions.grupo_insumo"
               theme="bootstrap"
               id="grupo_insumo"
               name="grupo_insumo"
               required
               append-to-body="true">
      <ui-select-match allow-clear="true" placeholder="Selecione o grupo de insumos">{{$select.selected.descricao | capitalize}}</ui-select-match>
        <ui-select-choices repeat="grupo_insumo in (widget.dataModelOptions.propriedade || $root.currentPropriedade).grupos_insumo | orderBy: 'descricao' | filter: $select.search track by grupo_insumo.id">
        <span class="form-group" ng-bind-html="grupo_insumo.descricao | capitalize | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
  </div>
  <div class="col-xs-6">
    <ui-select ng-model="widget.dataModelOptions.tipo"
               theme="bootstrap"
               id="tipo"
               name="tipo"
               required
               append-to-body="true">
      <ui-select-match allow-clear="true" placeholder="Selecione o tipo de praga">{{$select.selected.descricao | capitalize}}</ui-select-match>
      <ui-select-choices repeat="tipo in widget.data.tipos | orderBy: 'descricao' | filter: $select.search track by tipo.id">
        <span class="form-group" ng-bind-html="tipo.descricao | capitalize | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
  </div>
</div>
<hr ng-if="!widget.dataModelOptions.modal">
<div ng-repeat="chart in wctrl.charts" google-chart chart="chart" ng-style="wctrl.chartStyle" ng-if="wctrl.validChart() && !wctrl.empty && !wctrl.loading && !wctrl.error"></div>
<div class="alert alert-info" ng-if="!wctrl.validChart()">
  <p>Configure o gráfico antes de exibi-lo.</p>
</div>
<div class="alert alert-info" ng-if="!wctrl.loading && wctrl.empty && wctrl.validChart()">
  <p>Não há dados para serem exibidos.</p>
</div>
<div class="alert alert-danger" ng-if="wctrl.error">
  <p>Falha ao obter dados.</p>
</div>
<p class="history-day text-cinza text-center" ng-show="wctrl.loading">
  <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
</p>
